<template>
  <div class="jd-section jd-section--allowances">
    <p class="job-section__header">{{ $t('jobDetail.allowance') }}</p>
    <div v-if="allowances.length" class="jd-section__items">
      <job-allowance
        v-for="(allowance, i) in allowances"
        :key="`JobDetailAllowance${i}`"
        class="jd-section__item"
        :descriptions="allowance.descriptions"
        :name="allowance.name"
      />
    </div>
    <p v-else>{{ $t('general.notAvailable') }}</p>
  </div>
</template>

<script>
import JobAllowance from '../jobAllowance'

export default {
  components: {
    'job-allowance': JobAllowance,
  },
  props: {
    allowances: {
      default: () => [],
      type: Array,
    },
  },
}
</script>
